const DEFAULT_IDENTITY_LOGIN_BASE_URL =
  // "https://gotastebkid.azurewebsites.net/Identity/Account/Login";
  "https://www.identity.ps-env.com/Identity/Account/Login";
// "https://localhost:7219/Identity/Account/Login";
export function buildIdentityLoginUrl(returnUrl) {
  const baseUrl =
    process.env.REACT_APP_IDENTITY_LOGIN_URL || DEFAULT_IDENTITY_LOGIN_BASE_URL;
  const safeReturnUrl =
    returnUrl && typeof returnUrl === "string"
      ? returnUrl
      : window.location.origin;

  return `${baseUrl}?returnUrl=${encodeURIComponent(safeReturnUrl)}`;
}

export function redirectToIdentityLogin(returnUrl) {
  window.location.href = buildIdentityLoginUrl(returnUrl);
}

//Redirect code for password change
const localdataRaw = localStorage.getItem("sundorbonBookingUserDetails");

const localdata = localdataRaw ? JSON.parse(localdataRaw) : null;

const email = localdata?.Email;

const DEFAULT_IDENTITY_RESET_PASSWORD_URL = `https://www.identity.ps-env.com/Account/ChangePassword?email=${encodeURIComponent(email)}`;
// `https://localhost:7219/Identity/Account/ChangePassword?email=${encodeURIComponent(email)}`;

export function buildIdentityChangePasswordUrl(returnUrl) {
  if (!email) return null;

  const baseUrl =
    process.env.DEFAULT_IDENTITY_RESET_PASSWORD_URL ||
    DEFAULT_IDENTITY_RESET_PASSWORD_URL;

  return baseUrl;
}

export function redirectToIdentityChangesPassword(returnUrl) {
  if (!email) {
    return;
  }

  const url = buildIdentityChangePasswordUrl(returnUrl);
  if (url) {
    window.location.href = url;
  }
}
